export const MOCK_DATA: Record<string, any>[] = [
  {
    "schema_type": "QUOTE_EXPERIENCE_COLORS_CONTENT",
    "id": "9b18f04e-9d2d-42fe-9410-432699418323"
  },
  {
    "schema_type": "QUOTE_EXPERIENCE_TYPOGRAPHY",
    "id": "150b1a2c-019c-4fdb-a6e6-b7841c1d5cf4"
  },
  {
    "schema_type": "QUOTE_EXPERIENCE_COLORS",
    "id": "99c0429f-fa16-4b95-b434-4d8711828bcc"
  },
  {
    "schema_type": "QUOTE_EXPERIENCE_CONFIG",
    "id": "eb78ebef-1be2-4a01-94f4-85e1a4772813"
  },
  {
    "schema_type": "QUOTE_EXPERIENCE_LOCALIZATIONS",
    "id": "d640aa9a-c0d3-4fc1-8398-be2c3f68ac03"
  },
  {
    "schema_type": "QUOTE_EXPERIENCE_ICONS",
    "id": "78e327f3-4357-454c-9097-a8b5df95505a"
  },
  {
    "schema_type": "QUOTE_EXPERIENCE_IMAGES",
    "id": "479d78fa-9b1e-4bdc-b001-789ffeaf4394"
  },
  {
    "schema_type": "AGGREGATOR",
    "id": "fa8455e9-2c41-4814-836b-b1e4b9117731"
  },
  {
    "schema_type": "CAMPAIGN",
    "id": "5ec483de-88d2-4cd9-ac99-3692ef2fe0d6"
  },
  {
    "schema_type": "PARTNER",
    "id": "4c45701b-5f09-486f-8bc0-ef223133cd04"
  },
  {
    "schema_type": "CAMPAIGN_MEDIUM",
    "id": "446403fa-8e14-4491-97e1-43ebdcc41e65"
  },
  {
    "schema_type": "CAMPAIGN_SOURCE",
    "id": "9a782f32-6b9a-49d1-9109-fe4091ec3a7a"
  },
  {
    "schema_type": "CAMPAIGN_CONTENT",
    "id": "b5ddbcb3-37a7-4304-97ae-6af28681aa84"
  },
  {
    "schema_type": "BORROWER",
    "id": "f6fd27c1-176b-4466-bf7e-4167917d4679"
  },
  {
    "schema_type": "AGENT_ID",
    "id": "813b3068-203b-4395-8298-d6606cbf38ad"
  },
  {
    "schema_type": "AGENT_NAME",
    "id": "d6866cde-adc4-4a7f-9876-41ff7dd43d75"
  },
  {
    "schema_type": "ORIGINATING_CAMPAIGN",
    "id": "06b68cc8-1269-4c44-b414-9a72eae264d7"
  },
  {
    "schema_type": "SEMSEE_IDENTIFICATION",
    "id": "b2f2c335-cd57-4ca2-be7a-fc4a68838560"
  }
];